import React from "react";
import { Alert } from "react-bootstrap";
import { isEn } from "app/i18n/i18n";
import { BASENAME } from "lib/routing";

export const CoverageDisclaimer = () => isEn() ? <CoverageDisclaimerEn/> : <CoverageDisclaimerJa/>

function CoverageDisclaimerEn() {
  return (
    <Alert variant="light m-2 p-2 small">
      <b>Note:</b> Ratings and target prices are as of the date of the most recently published report, which is
      available by clicking a company name above. Please refer to the last published research report for details of
      valuation methodology and investment risks.
      <hr />
      Disclosure information is available on the
      <DisclosureLink />
      page.
    </Alert>
  );
}

function CoverageDisclaimerJa() {
  return (
    <Alert variant="light m-2 p-2 small">
      <b>ご注意ください：</b>
      本ページに表示されているレーティング及び目標株価は、それぞれの企業名をクリックすると表示される最新のレポート発行日現在のものです。 レーティングシステム及び目標株価については、最新のレポートの末尾に記載されておりますので、当該ページをお開きいただき、よくお読みください。
      <hr />
      また、企業に関するディスクロージャーはこちらのページからご参照ください
      <DisclosureLink />
    </Alert>
  );
}

const DisclosureLink = () => (
  <Alert.Link href={BASENAME + "/Disclosures"}>
    {" "}
    Nomura Disclosures{" "}
  </Alert.Link>
);
